import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { getFeatureFreezeAutoRenewal } from 'reactApp/modules/features/features.selectors';

interface IProps {
    onClose: () => void;
}

const BUTTONS = [];

export const FreezeRenewalModal = memo<IProps>(({ onClose }) => {
    const promocode = useSelector(getFeatureFreezeAutoRenewal);

    const renderHeader = useCallback(() => 'В разработке', []);
    const renderContent = useCallback(
        () => (
            <div>
                Спасибо за ваш интерес.
                <br />
                Мы уведомим вас после запуска заморозки подписки.
                <br />
                Держите в подарок промокод скидку 60% на 1ТБ на 1 год: <b>{promocode}</b>
            </div>
        ),
        [promocode]
    );

    return (
        <BaseConfirmDialog
            dataQAId="freeze-renewal-dialog"
            renderHeader={renderHeader}
            onClose={onClose}
            renderContent={renderContent}
            closeOnDimmerClick
            buttons={BUTTONS}
        />
    );
});

FreezeRenewalModal.displayName = 'FreezeRenewalModal';
